import React, {useState, useContext} from 'react';
import EquipTable from '../../tables/equipTables/EquipTable'

import { AllEquipsContext } from '../../../context/allEquips-context';
import { CurrentEquipContext } from '../../../context/currentEquip-context';

export default function EquipsTabPanel(props) {
  console.log("render EquipsTabPanel");

  const [currEquipState, currEquipDispatch] = useContext(CurrentEquipContext);
  const [allEquipsState, allEquipsDispatch] = useContext(AllEquipsContext);

  return (
    <div>
      <EquipTable data={allEquipsState.allEquips} equipInfo={currEquipState.equipInfo}/>
    </div>
  );
}